"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Config_1 = __importDefault(require("../Config"));
const Auth_1 = require("./Auth");
const DateHelper_1 = require("./DateHelper");
const API_BASE = Config_1.default.api.baseUrl;
async function getSettings() {
    const url = `${API_BASE}/api/GetSettings`;
    const params = {
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + await Auth_1.getAccessToken('functionApi')
        },
    };
    // Currently there is only one setting returned
    return await fetch(url, params).then(res => res.json()).then(response => {
        var _a;
        return {
            ...response,
            data: {
                harvestEmployeeMapping: JSON.parse((_a = response.data.find((datum) => datum.key == 'harvest-user-mapping')) === null || _a === void 0 ? void 0 : _a.value)
            }
        };
    });
}
exports.getSettings = getSettings;
async function updateSettings(newSettings) {
    const url = `${API_BASE}/api/UpdateSettings`;
    const settingsPayload = [
        {
            key: 'harvest-user-mapping',
            value: newSettings.harvestEmployeeMapping.filter(x => x.harvestName.length && x.employeeCode.length)
        }
    ];
    const params = {
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + await Auth_1.getAccessToken('functionApi'),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(settingsPayload)
    };
    return await fetch(url, params).then(res => res.json());
}
exports.updateSettings = updateSettings;
async function getLogs(queryParams) {
    if (queryParams.filterByLevel === 'ALL')
        delete queryParams.filterByLevel;
    const url = `${API_BASE}/api/GetLogs?${queryParamsToString(queryParams)}`;
    const params = {
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + await Auth_1.getAccessToken('functionApi'),
            'Content-Type': 'application/json'
        }
    };
    return await fetch(url, params).then(res => res.json());
}
exports.getLogs = getLogs;
async function getHarvestImportStatus(queryParams) {
    const url = `${API_BASE}/api/GetHarvestImportStatus?${queryParamsToString(queryParams)}`;
    const params = {
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + await Auth_1.getAccessToken('functionApi')
        }
    };
    const response = await fetch(url, params);
    return {
        success: response.ok,
        error: !response.ok ? response.statusText : undefined,
        httpStatusCode: response.status,
        httpStatusMessage: response.statusText,
        data: await response.json()
    };
}
exports.getHarvestImportStatus = getHarvestImportStatus;
async function startHarvestImport(importSettings) {
    const url = `${API_BASE}/api/StartHarvestImport`;
    const params = {
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + await Auth_1.getAccessToken('functionApi'),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            from: DateHelper_1.iso8601Date(importSettings.from),
            to: DateHelper_1.iso8601Date(importSettings.to)
        })
    };
    const response = await fetch(url, params);
    return {
        success: response.status >= 200 && response.status <= 300,
        error: response.status >= 300 ? response.statusText : undefined,
        httpStatusCode: response.status,
        httpStatusMessage: response.statusText,
        data: await response.json()
    };
}
exports.startHarvestImport = startHarvestImport;
/********************
 * Helpers
 ********************/
function queryParamsToString(params) {
    return Object.keys(params)
        .filter(k => typeof params[k] !== 'undefined')
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');
}
